import { api } from "..";

interface BanDealerPayload {
  dealerId: number;
  reason?: string | null;
  expiresAt?: string | null;
}

interface UnbanDealerPayload {
  dealerId: number;
}

export async function banDealer(
  payload: BanDealerPayload
): Promise<{ success: boolean }> {
  const { dealerId, ...body } = payload;
  const res = await api.client.put(`/dealers-new/${dealerId}/ban`, body);
  return res.data;
}

export async function unbanDealer(
  payload: UnbanDealerPayload
): Promise<{ success: boolean }> {
  const res = await api.client.delete(`/dealers-new/${payload.dealerId}/ban`);
  return res.data;
}
